import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import useStore from '../store/store';
import { SessionTimeout, Store } from '../store/types';
import { AlertBoxData } from '../components/types';

export interface CommonHandlers {
    errorMessage: (message: string) => void,
    successMessage: (message: string) => void,
    infoMessage: (message: string) => void,
    showSpinner: () => void,
    hideSpinner: () => void,
    showAlertBox: (alertBoxData: AlertBoxData) => void,
    setSessionTimeout: (sessionTimeout: SessionTimeout) => void,
    setAppVersionMismatch: (setAppVersionMismatch: boolean) => void,
}

export const useCommonMessageAndSpinnerHandlers = (): CommonHandlers => {
    const { enqueueSnackbar } = useSnackbar();
    const showSpinner = useStore((state: Store) => state.showSpinner);
    const hideSpinner = useStore((state: Store) => state.hideSpinner);
    const showAlertBox = useStore((state: Store) => state.showAlertBox);
    const setSessionTimeout = useStore((state: Store) => state.setSessionTimeout);
    const setAppVersionMismatch = useStore((state: Store) => state.setAppVersionMismatch);
    const errorMessage = (message: string) => {
        enqueueSnackbar(message, {
            variant: 'error',
        });
    };
    const successMessage = (message: string) => {
        enqueueSnackbar(message, {
            variant: 'success',
        });
    };

    const infoMessage = (message: string) => {
        enqueueSnackbar(message, {
            variant: 'info',
        });
    };

    return {
        showSpinner,
        hideSpinner,
        showAlertBox,
        errorMessage: useCallback(errorMessage, [enqueueSnackbar]),
        successMessage: useCallback(successMessage, [enqueueSnackbar]),
        infoMessage: useCallback(infoMessage, [enqueueSnackbar]),
        setSessionTimeout,
        setAppVersionMismatch,
    };
};
